import flow from 'lodash/flow';
import { SortDirection } from 'src/components/DataTable/types/DataTable';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { Employee, EmployeeSearchResultItem, ROLES } from 'src/types/Employee';
import {
  transformPhoneNumberUIToModel,
  transformPhoneNumberModelToUI,
} from 'src/components/enterprise/features/Employee/components/Form/controls/PhoneNumberControl/phoneNumber.utils';
import { transformLocationUIToModel } from 'src/components/enterprise/features/Employee/components/Form/controls/LocationsSelectSearchControlWrapper/location.utils';
import { transformDepartmentUIToModel } from 'src/components/enterprise/features/Employee/components/Form/controls/DepartmentsSelectSearchControlWrapper/department.utils';
import { transformSubDepartmentUIToModel } from 'src/components/enterprise/features/Employee/components/Form/controls/SubDepartmentControlWrapper/subDepartment.utils';
import { transformSsoIdentifierUIToModel } from 'src/components/enterprise/features/Employee/components/Form/controls/SsoIdentifierWrapper/ssoIdentifier.utils';
import { CorpUIResponse, SsoIdentifierTypes } from 'src/types/Corp';

export enum EmployeeListSortField {
  LAST_NAME = 'LAST_NAME',
}

export type EmployeeListFilters = {
  query?: string;
  diner_role?: ROLES;
};

export const initialEmployeeListTableState = {
  sortField: EmployeeListSortField.LAST_NAME,
  sortOrder: SortDirection.ASC,
};

export function getEmployeeNameForList({
  firstName,
  lastName,
}: Pick<EmployeeSearchResultItem, 'firstName' | 'lastName'>): string {
  return `${lastName}, ${firstName}`;
}

export function transformEmployeeFormToPayload(
  values: Partial<EmployeeFormFields>,
  corpData: CorpUIResponse
): Employee {
  const transform = flow([
    transformSsoIdentifierUIToModel(
      corpData.ssoIdentifier as SsoIdentifierTypes
    ),
    transformPhoneNumberUIToModel,
    transformLocationUIToModel,
    transformDepartmentUIToModel,
    transformSubDepartmentUIToModel,
  ]);
  return transform(values);
}

export function mergeCorpDinerSettings(
  merged: Employee,
  existingData: Employee
): Employee['corpDinerSettings'] {
  if (!existingData.corpDinerSettings?.sentWelcomeEmail) {
    return merged.corpDinerSettings;
  }

  return {
    ...merged.corpDinerSettings,
    sentWelcomeEmail: existingData.corpDinerSettings.sentWelcomeEmail,
  };
}

export function extendEmployeeModel(
  values: Partial<EmployeeFormFields>,
  existingData: Employee
): Employee {
  const merged = { ...existingData, ...values };

  return {
    ...merged,
    corpDinerSettings: mergeCorpDinerSettings(merged, existingData),
  };
}

export function transformEmployeeModelToForm(
  values: Employee
): EmployeeFormFields {
  const transform = flow([transformPhoneNumberModelToUI]);

  return transform(values);
}
